import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Slide } from '@material-ui/core';
import { TopMedsos, TopBar, Footer } from '..';
// import { postVisitor } from "../../../services";
import Context from '../../../context';

const DataNav = [
  {
    title: 'Beranda',
    titleEn: 'Home',
    link: '/',
    exact: true,
  },
  {
    title: 'Tentang Kami',
    titleEn: 'About Us',
    link: '/tentang-kami',
    exact: false,
    children: [
      {
        title: 'Sejarah Perusahaan',
        titleEn: 'Company History',
        link: '/tentang-kami/sejarah-perusahaan',
        exact: true,
      },
      {
        title: 'Visi & Misi',
        titleEn: 'Vision & Mission',
        link: '/tentang-kami/visi-misi',
        exact: true,
      },
      {
        title: 'Struktur Organisasi',
        titleEn: 'Organization Structure',
        link: '/tentang-kami/struktur-organisasi',
        exact: true,
      },
      {
        title: 'Penghargaan',
        titleEn: 'Achievements',
        link: '/tentang-kami/penghargaan',
        exact: true,
      },
    ],
  },
  {
    title: 'Jalan Tol Kami',
    titleEn: 'Our Toll Road',
    link: '/jalan-tol-kami',
    exact: false,
    children: [
      {
        title: 'Informasi Tol',
        titleEn: 'Toll Information',
        link: '/jalan-tol-kami/informasi-tol',
        exact: true,
      },
      {
        title: 'Teknologi Kami',
        titleEn: 'Our Technology',
        link: '/jalan-tol-kami/teknologi-kami',
        exact: true,
      },
      {
        title: 'Live CCTV',
        titleEn: 'Live CCTV',
        link: '/jalan-tol-kami/live-cctv',
        exact: true,
      },
      {
        title: 'Virtual Tour Toll Road',
        titleEn: 'Virtual Tour Toll Road',
        link: '/jalan-tol-kami/virtual-tour-toll-road',
        exact: true,
      },
    ],
  },
  {
    title: 'Ruang Berita',
    titleEn: 'News Room',
    link: '/ruang-berita',
    exact: false,
    children: [
      {
        title: 'Berita',
        titleEn: 'News',
        link: '/ruang-berita/berita',
        exact: true,
      },
      {
        title: 'Aktifitas',
        titleEn: 'Activity',
        link: '/ruang-berita/kegiatan',
        exact: true,
      },
      {
        title: 'Pengumuman',
        titleEn: 'Announcement',
        link: '/ruang-berita/pengumuman',
        exact: true,
        children: [
          {
            title: 'Lowongan Pekerjaan',
            titleEn: 'Job Vacancy',
            link: '/ruang-berita/lowongan-pekerjaan',
            exact: true,
          },
          {
            title: 'Pengadaan Barang / Jasa',
            titleEn: 'Procurement of Goods / Services',
            link: '/ruang-berita/pengadaan-barang-jasa',
            exact: true,
          },
          {
            title: 'Pengumuman Lainnya',
            titleEn: 'Other Announcement',
            link: '/ruang-berita/pengumuman-lainnya',
            exact: true,
          },
        ],
      },
    ],
  },
];

const LayoutLandingPages = ({ children }: { children: ReactNode }) => {
  // const trigger = useScrollTrigger();
  const location = useLocation();
  const context = React.useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === 'ID' ? true : false;

  return (
    <>
      <Slide appear={false} direction='down' in={true}>
        <div style={{ width: '100%', position: 'fixed', top: '0', zIndex: 2 }}>
          <TopMedsos />
          <TopBar
            dataNav={DataNav}
            isId={isId}
            changeLang={context.changeLang}
          />
        </div>
      </Slide>
      {children}
      {location.pathname !== '/' && <Footer dataNav={DataNav} isId={isId} />}
    </>
  );
};

export default LayoutLandingPages;
